import axiosInstance from 'utils/axiosInstance';
import { get } from 'lodash/fp';

const getCohealerIncome = data => axiosInstance.get('/api/cohealer-income/total', data).then(get('data'));

export { getCohealerIncome };
